module.exports = __webpack_public_path__ + "static/media/YB5M05_0.16d6d4dd.jpg";